import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

import Home from './Pages/Home';
import Verified from './Pages/Verified';
import Signin from './Pages/Signin';
import Main from './Pages/Main';
import TenantProfile from './Pages/TenantProfile';

import { Navigation } from './Components/Navigation';
import { Footer } from './Components/Footer';

import { LOCAL_ENDPOINTS } from './config';
import axios from 'axios';

class LandingPage extends Component{

  constructor(props){
    super(props);
    this.state = {
      url: ""
    }
  }

  componentDidMount = async () => {
  }
  redirect = async () => {
    let request_url = window.location.href;

    await axios({
      method: "GET",
      url: LOCAL_ENDPOINTS.buildURL,
    }).then((result) => {

      console.log("Build URL",LOCAL_ENDPOINTS.buildURL);
      if (!result.data.Success)
        alert(result.data.Message);
      else
        switch(true) {
          case (request_url.includes("requestAUTH-sg")):
            window.location.replace(result.data.UrlSG);
            break;
          case (request_url.includes("requestAUTH-hk")):
            window.location.replace(result.data.UrlHK);
            break;
          case (request_url.includes("requestAUTH-ms")):
            window.location.replace(result.data.UrlMS);
            break;
          case (request_url.includes("requestAUTH-au")):
            window.location.replace(result.data.UrlAU);
            break;
          case (request_url.includes("requestAUTH-uk")):
            window.location.replace(result.data.UrlUK);
            break;
          case (request_url.includes("requestAUTH-in")):
            window.location.replace(result.data.UrlIN);
            break;
          case (request_url.includes("requestAUTH-al")):
            window.location.replace(result.data.UrlAL);
            break;
        }
    });
  }

  render() {
    const { url } = this.state;

    const path = url;

    return(
        <Router>
          <Home>
            <Navigation></Navigation>
            <Switch>
              <Redirect strict exact from="/" to="/signin" ></Redirect>
              <Route path='/signin' component={Signin}></Route>
              <Route path='/requestAUTH-sg' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path='/requestAUTH-hk' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path='/requestAUTH-ms' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path='/requestAUTH-au' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path='/requestAUTH-uk' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path='/requestAUTH-in' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path='/requestAUTH-al' component={ () => {
                this.redirect();
                return null;
              }}/>
              <Route path="/verified-sg" component={Verified}></Route>
              <Route path="/verified-hk" component={Verified}></Route>
              <Route path="/verified-ms" component={Verified}></Route>
              <Route path="/verified-au" component={Verified}></Route>
              <Route path="/verified-uk" component={Verified}></Route>
              <Route path="/verified-in" component={Verified}></Route>
              <Route path="/verified-al" component={Verified}></Route>
              <Route path="/main" component={Main}></Route>
              <Route path="/tenant/:tenantId" component={TenantProfile}></Route>
            </Switch>
          </Home>
          <Footer></Footer>
        </Router>
    )
  }
}


export default LandingPage;
